import { render, staticRenderFns } from "./ReportsDeliveryReceiverView.vue?vue&type=template&id=46d3c3de"
import script from "./ReportsDeliveryReceiverView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryReceiverView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports